import React from "react";
import { TagsContextInterface, NavigationSetWithFlag } from "types/tags";

export const TagsContext = React.createContext<TagsContextInterface>({
  navigationSets: [],
  setNavigationSets: (_navigationSets: NavigationSetWithFlag[]) => {},
});
